import { createContext } from 'react'

const odsWrapperContext = createContext({})

export default odsWrapperContext
